// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Cube from 'cube-ui'
// import fastClick from 'fastclick'
import request from '@/libs/request'
import selfCube from '@/libs/selfCube'
import wechat from '@/libs/wechat'
import wechatShare from '@/libs/wechatShare'
import store from '@/store'
import 'vue-area-linkage/dist/index.css'
import VueAreaLinkage from 'vue-area-linkage'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(Cube)
Vue.use(request)
Vue.use(selfCube)
Vue.use(VueAreaLinkage)

Vue.use(wechat)
Vue.use(wechatShare)
// fastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
export default vm



// WEBPACK FOOTER //
// ./src/main.js